import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('vm-chat-inline')
export class VmChatInline extends LitElement {
    override createRenderRoot() {
        return this;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-chat-inline': VmChatInline;
    }
}
